(() => {
  const root = document.querySelector("#MainContent[data-template^='product']");
  if (!root || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  document.documentElement.classList.add('fk-product-motion');
  const sections = [...root.querySelectorAll(':scope > .shopify-section')];
  const staggerSelector = [
    '.fk-card', '.fk-reco__item', '.fk-cols__item', '.fk-faq__item', '.fk-review',
    '.product-information__media', '.product-details > .group-block', '.fk-mwt__media', '.fk-mwt__content'
  ].join(',');

  sections.forEach((section) => {
    const children = [...section.querySelectorAll(staggerSelector)].filter((item) => !item.closest('.fk-reveal'));
    if (children.length) {
      children.forEach((item, index) => {
        item.classList.add('fk-reveal');
        item.style.setProperty('--fk-delay', `${Math.min(index, 7) * 70}ms`);
      });
    } else {
      section.classList.add('fk-reveal');
    }
  });

  const reveal = (element) => element.classList.add('is-visible');
  if (!('IntersectionObserver' in window)) {
    root.querySelectorAll('.fk-reveal').forEach(reveal);
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      reveal(entry.target);
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: .08 });

  root.querySelectorAll('.fk-reveal').forEach((element) => observer.observe(element));
})();
